import { Stack, styled } from '@mui/material';

export const StatusHeaderRow = styled(Stack)(() => ({
  flexDirection: 'row',
  alignItems: 'center',
  alignSelf: 'stretch',
  gap: '0.625rem',
  padding: '0.75rem 1.5rem',
  width: '100%',
  backgroundColor: '#FEFEFE',
}));

export const StatusTitle = styled('p')(({ theme }) => ({
  margin: 0,
  fontSize: '1.125rem',
  fontWeight: 500,
  lineHeight: '100%',
  color: theme.palette.grey[900],
}));

export const StatusInfoBox = styled('div')(({ theme }) => ({
  display: 'flex',
  width: '100%',
  alignItems: 'flex-start',
  alignSelf: 'stretch',
  gap: '0.625rem',
  borderRadius: '0.75rem',
  border: `1px solid ${theme.palette.grey[100]}`,
  backgroundColor: '#FEFEFE',
  padding: '0.75rem',
}));

export const StatusInfoStack = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'flex-start',
  gap: '0.25rem',
  flex: '1 0 0',
  width: '100%',
}));

export const StatusInfoLine = styled('p')(({ theme }) => ({
  margin: 0,
  fontSize: '0.875rem',
  fontWeight: 500,
  lineHeight: '130%',
  color: theme.palette.grey[900],
}));

export const StatusInfoDetailLine = styled('p')(({ theme }) => ({
  margin: 0,
  fontSize: '0.75rem',
  fontWeight: 400,
  lineHeight: '125%',
  color: theme.palette.grey[900],
}));
